module.exports = __webpack_public_path__ + "static/media/acba-30.9f42644d.png";